// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v7.34.1
// source: variables.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import Long from "long";
import { Timestamp } from "./google/protobuf/timestamp";

export const protobufPackage = "variables";

export interface VariablesMap {
  variables: { [key: string]: boolean };
}

export interface VariablesMap_VariablesEntry {
  key: string;
  value: boolean;
}

export interface VariableReferences {
  /** functions */
  functions: { [key: string]: boolean };
  delayResponses: { [key: string]: boolean };
  /** flows */
  flowSteps: { [key: string]: boolean };
  flowNoCodeSteps: { [key: string]: boolean };
  flowFunctions: { [key: string]: boolean };
  /** knowledge base */
  topics: { [key: string]: boolean };
  /** agent settings */
  behaviours: { [key: string]: boolean };
  greetings: { [key: string]: boolean };
  roles: { [key: string]: boolean };
  personalities: { [key: string]: boolean };
  /** sms */
  sms: { [key: string]: boolean };
  /** special functions */
  startFunctions: { [key: string]: boolean };
  endFunctions: { [key: string]: boolean };
}

export interface VariableReferences_FunctionsEntry {
  key: string;
  value: boolean;
}

export interface VariableReferences_DelayResponsesEntry {
  key: string;
  value: boolean;
}

export interface VariableReferences_FlowStepsEntry {
  key: string;
  value: boolean;
}

export interface VariableReferences_FlowNoCodeStepsEntry {
  key: string;
  value: boolean;
}

export interface VariableReferences_FlowFunctionsEntry {
  key: string;
  value: boolean;
}

export interface VariableReferences_TopicsEntry {
  key: string;
  value: boolean;
}

export interface VariableReferences_BehavioursEntry {
  key: string;
  value: boolean;
}

export interface VariableReferences_GreetingsEntry {
  key: string;
  value: boolean;
}

export interface VariableReferences_RolesEntry {
  key: string;
  value: boolean;
}

export interface VariableReferences_PersonalitiesEntry {
  key: string;
  value: boolean;
}

export interface VariableReferences_SmsEntry {
  key: string;
  value: boolean;
}

export interface VariableReferences_StartFunctionsEntry {
  key: string;
  value: boolean;
}

export interface VariableReferences_EndFunctionsEntry {
  key: string;
  value: boolean;
}

export interface Variable {
  id: string;
  name: string;
  createdBy: string;
  createdAt: Date | undefined;
  updatedBy: string;
  updatedAt: Date | undefined;
  references: VariableReferences | undefined;
}

export interface Variables {
  entities: Variable[];
}

export interface VariableCreate {
  id: string;
  name: string;
  references: VariableReferences | undefined;
}

export interface VariableUpdate {
  id: string;
  name: string;
  references: VariableReferences | undefined;
}

export interface VariableDelete {
  id: string;
}

function createBaseVariablesMap(): VariablesMap {
  return { variables: {} };
}

export const VariablesMap: MessageFns<VariablesMap> = {
  encode(message: VariablesMap, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    globalThis.Object.entries(message.variables).forEach(([key, value]: [string, boolean]) => {
      VariablesMap_VariablesEntry.encode({ key: key as any, value }, writer.uint32(10).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VariablesMap {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVariablesMap();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = VariablesMap_VariablesEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.variables[entry1.key] = entry1.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VariablesMap {
    return {
      variables: isObject(object.variables)
        ? (globalThis.Object.entries(object.variables) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: VariablesMap): unknown {
    const obj: any = {};
    if (message.variables) {
      const entries = globalThis.Object.entries(message.variables) as [string, boolean][];
      if (entries.length > 0) {
        obj.variables = {};
        entries.forEach(([k, v]) => {
          obj.variables[k] = v;
        });
      }
    }
    return obj;
  },

  create(base?: DeepPartial<VariablesMap>): VariablesMap {
    return VariablesMap.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<VariablesMap>): VariablesMap {
    const message = createBaseVariablesMap();
    message.variables = (globalThis.Object.entries(object.variables ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseVariablesMap_VariablesEntry(): VariablesMap_VariablesEntry {
  return { key: "", value: false };
}

export const VariablesMap_VariablesEntry: MessageFns<VariablesMap_VariablesEntry> = {
  encode(message: VariablesMap_VariablesEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VariablesMap_VariablesEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVariablesMap_VariablesEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VariablesMap_VariablesEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: VariablesMap_VariablesEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<VariablesMap_VariablesEntry>): VariablesMap_VariablesEntry {
    return VariablesMap_VariablesEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<VariablesMap_VariablesEntry>): VariablesMap_VariablesEntry {
    const message = createBaseVariablesMap_VariablesEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseVariableReferences(): VariableReferences {
  return {
    functions: {},
    delayResponses: {},
    flowSteps: {},
    flowNoCodeSteps: {},
    flowFunctions: {},
    topics: {},
    behaviours: {},
    greetings: {},
    roles: {},
    personalities: {},
    sms: {},
    startFunctions: {},
    endFunctions: {},
  };
}

export const VariableReferences: MessageFns<VariableReferences> = {
  encode(message: VariableReferences, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    globalThis.Object.entries(message.functions).forEach(([key, value]: [string, boolean]) => {
      VariableReferences_FunctionsEntry.encode({ key: key as any, value }, writer.uint32(10).fork()).join();
    });
    globalThis.Object.entries(message.delayResponses).forEach(([key, value]: [string, boolean]) => {
      VariableReferences_DelayResponsesEntry.encode({ key: key as any, value }, writer.uint32(18).fork()).join();
    });
    globalThis.Object.entries(message.flowSteps).forEach(([key, value]: [string, boolean]) => {
      VariableReferences_FlowStepsEntry.encode({ key: key as any, value }, writer.uint32(26).fork()).join();
    });
    globalThis.Object.entries(message.flowNoCodeSteps).forEach(([key, value]: [string, boolean]) => {
      VariableReferences_FlowNoCodeStepsEntry.encode({ key: key as any, value }, writer.uint32(34).fork()).join();
    });
    globalThis.Object.entries(message.flowFunctions).forEach(([key, value]: [string, boolean]) => {
      VariableReferences_FlowFunctionsEntry.encode({ key: key as any, value }, writer.uint32(42).fork()).join();
    });
    globalThis.Object.entries(message.topics).forEach(([key, value]: [string, boolean]) => {
      VariableReferences_TopicsEntry.encode({ key: key as any, value }, writer.uint32(50).fork()).join();
    });
    globalThis.Object.entries(message.behaviours).forEach(([key, value]: [string, boolean]) => {
      VariableReferences_BehavioursEntry.encode({ key: key as any, value }, writer.uint32(58).fork()).join();
    });
    globalThis.Object.entries(message.greetings).forEach(([key, value]: [string, boolean]) => {
      VariableReferences_GreetingsEntry.encode({ key: key as any, value }, writer.uint32(66).fork()).join();
    });
    globalThis.Object.entries(message.roles).forEach(([key, value]: [string, boolean]) => {
      VariableReferences_RolesEntry.encode({ key: key as any, value }, writer.uint32(74).fork()).join();
    });
    globalThis.Object.entries(message.personalities).forEach(([key, value]: [string, boolean]) => {
      VariableReferences_PersonalitiesEntry.encode({ key: key as any, value }, writer.uint32(82).fork()).join();
    });
    globalThis.Object.entries(message.sms).forEach(([key, value]: [string, boolean]) => {
      VariableReferences_SmsEntry.encode({ key: key as any, value }, writer.uint32(90).fork()).join();
    });
    globalThis.Object.entries(message.startFunctions).forEach(([key, value]: [string, boolean]) => {
      VariableReferences_StartFunctionsEntry.encode({ key: key as any, value }, writer.uint32(98).fork()).join();
    });
    globalThis.Object.entries(message.endFunctions).forEach(([key, value]: [string, boolean]) => {
      VariableReferences_EndFunctionsEntry.encode({ key: key as any, value }, writer.uint32(106).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VariableReferences {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVariableReferences();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = VariableReferences_FunctionsEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.functions[entry1.key] = entry1.value;
          }
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          const entry2 = VariableReferences_DelayResponsesEntry.decode(reader, reader.uint32());
          if (entry2.value !== undefined) {
            message.delayResponses[entry2.key] = entry2.value;
          }
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          const entry3 = VariableReferences_FlowStepsEntry.decode(reader, reader.uint32());
          if (entry3.value !== undefined) {
            message.flowSteps[entry3.key] = entry3.value;
          }
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          const entry4 = VariableReferences_FlowNoCodeStepsEntry.decode(reader, reader.uint32());
          if (entry4.value !== undefined) {
            message.flowNoCodeSteps[entry4.key] = entry4.value;
          }
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          const entry5 = VariableReferences_FlowFunctionsEntry.decode(reader, reader.uint32());
          if (entry5.value !== undefined) {
            message.flowFunctions[entry5.key] = entry5.value;
          }
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          const entry6 = VariableReferences_TopicsEntry.decode(reader, reader.uint32());
          if (entry6.value !== undefined) {
            message.topics[entry6.key] = entry6.value;
          }
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          const entry7 = VariableReferences_BehavioursEntry.decode(reader, reader.uint32());
          if (entry7.value !== undefined) {
            message.behaviours[entry7.key] = entry7.value;
          }
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          const entry8 = VariableReferences_GreetingsEntry.decode(reader, reader.uint32());
          if (entry8.value !== undefined) {
            message.greetings[entry8.key] = entry8.value;
          }
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          const entry9 = VariableReferences_RolesEntry.decode(reader, reader.uint32());
          if (entry9.value !== undefined) {
            message.roles[entry9.key] = entry9.value;
          }
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          const entry10 = VariableReferences_PersonalitiesEntry.decode(reader, reader.uint32());
          if (entry10.value !== undefined) {
            message.personalities[entry10.key] = entry10.value;
          }
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          const entry11 = VariableReferences_SmsEntry.decode(reader, reader.uint32());
          if (entry11.value !== undefined) {
            message.sms[entry11.key] = entry11.value;
          }
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          const entry12 = VariableReferences_StartFunctionsEntry.decode(reader, reader.uint32());
          if (entry12.value !== undefined) {
            message.startFunctions[entry12.key] = entry12.value;
          }
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          const entry13 = VariableReferences_EndFunctionsEntry.decode(reader, reader.uint32());
          if (entry13.value !== undefined) {
            message.endFunctions[entry13.key] = entry13.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VariableReferences {
    return {
      functions: isObject(object.functions)
        ? (globalThis.Object.entries(object.functions) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
      delayResponses: isObject(object.delayResponses)
        ? (globalThis.Object.entries(object.delayResponses) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : isObject(object.delay_responses)
        ? (globalThis.Object.entries(object.delay_responses) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
      flowSteps: isObject(object.flowSteps)
        ? (globalThis.Object.entries(object.flowSteps) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : isObject(object.flow_steps)
        ? (globalThis.Object.entries(object.flow_steps) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
      flowNoCodeSteps: isObject(object.flowNoCodeSteps)
        ? (globalThis.Object.entries(object.flowNoCodeSteps) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : isObject(object.flow_no_code_steps)
        ? (globalThis.Object.entries(object.flow_no_code_steps) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
      flowFunctions: isObject(object.flowFunctions)
        ? (globalThis.Object.entries(object.flowFunctions) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : isObject(object.flow_functions)
        ? (globalThis.Object.entries(object.flow_functions) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
      topics: isObject(object.topics)
        ? (globalThis.Object.entries(object.topics) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
      behaviours: isObject(object.behaviours)
        ? (globalThis.Object.entries(object.behaviours) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
      greetings: isObject(object.greetings)
        ? (globalThis.Object.entries(object.greetings) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
      roles: isObject(object.roles)
        ? (globalThis.Object.entries(object.roles) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
      personalities: isObject(object.personalities)
        ? (globalThis.Object.entries(object.personalities) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
      sms: isObject(object.sms)
        ? (globalThis.Object.entries(object.sms) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
      startFunctions: isObject(object.startFunctions)
        ? (globalThis.Object.entries(object.startFunctions) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : isObject(object.start_functions)
        ? (globalThis.Object.entries(object.start_functions) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
      endFunctions: isObject(object.endFunctions)
        ? (globalThis.Object.entries(object.endFunctions) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : isObject(object.end_functions)
        ? (globalThis.Object.entries(object.end_functions) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: VariableReferences): unknown {
    const obj: any = {};
    if (message.functions) {
      const entries = globalThis.Object.entries(message.functions) as [string, boolean][];
      if (entries.length > 0) {
        obj.functions = {};
        entries.forEach(([k, v]) => {
          obj.functions[k] = v;
        });
      }
    }
    if (message.delayResponses) {
      const entries = globalThis.Object.entries(message.delayResponses) as [string, boolean][];
      if (entries.length > 0) {
        obj.delayResponses = {};
        entries.forEach(([k, v]) => {
          obj.delayResponses[k] = v;
        });
      }
    }
    if (message.flowSteps) {
      const entries = globalThis.Object.entries(message.flowSteps) as [string, boolean][];
      if (entries.length > 0) {
        obj.flowSteps = {};
        entries.forEach(([k, v]) => {
          obj.flowSteps[k] = v;
        });
      }
    }
    if (message.flowNoCodeSteps) {
      const entries = globalThis.Object.entries(message.flowNoCodeSteps) as [string, boolean][];
      if (entries.length > 0) {
        obj.flowNoCodeSteps = {};
        entries.forEach(([k, v]) => {
          obj.flowNoCodeSteps[k] = v;
        });
      }
    }
    if (message.flowFunctions) {
      const entries = globalThis.Object.entries(message.flowFunctions) as [string, boolean][];
      if (entries.length > 0) {
        obj.flowFunctions = {};
        entries.forEach(([k, v]) => {
          obj.flowFunctions[k] = v;
        });
      }
    }
    if (message.topics) {
      const entries = globalThis.Object.entries(message.topics) as [string, boolean][];
      if (entries.length > 0) {
        obj.topics = {};
        entries.forEach(([k, v]) => {
          obj.topics[k] = v;
        });
      }
    }
    if (message.behaviours) {
      const entries = globalThis.Object.entries(message.behaviours) as [string, boolean][];
      if (entries.length > 0) {
        obj.behaviours = {};
        entries.forEach(([k, v]) => {
          obj.behaviours[k] = v;
        });
      }
    }
    if (message.greetings) {
      const entries = globalThis.Object.entries(message.greetings) as [string, boolean][];
      if (entries.length > 0) {
        obj.greetings = {};
        entries.forEach(([k, v]) => {
          obj.greetings[k] = v;
        });
      }
    }
    if (message.roles) {
      const entries = globalThis.Object.entries(message.roles) as [string, boolean][];
      if (entries.length > 0) {
        obj.roles = {};
        entries.forEach(([k, v]) => {
          obj.roles[k] = v;
        });
      }
    }
    if (message.personalities) {
      const entries = globalThis.Object.entries(message.personalities) as [string, boolean][];
      if (entries.length > 0) {
        obj.personalities = {};
        entries.forEach(([k, v]) => {
          obj.personalities[k] = v;
        });
      }
    }
    if (message.sms) {
      const entries = globalThis.Object.entries(message.sms) as [string, boolean][];
      if (entries.length > 0) {
        obj.sms = {};
        entries.forEach(([k, v]) => {
          obj.sms[k] = v;
        });
      }
    }
    if (message.startFunctions) {
      const entries = globalThis.Object.entries(message.startFunctions) as [string, boolean][];
      if (entries.length > 0) {
        obj.startFunctions = {};
        entries.forEach(([k, v]) => {
          obj.startFunctions[k] = v;
        });
      }
    }
    if (message.endFunctions) {
      const entries = globalThis.Object.entries(message.endFunctions) as [string, boolean][];
      if (entries.length > 0) {
        obj.endFunctions = {};
        entries.forEach(([k, v]) => {
          obj.endFunctions[k] = v;
        });
      }
    }
    return obj;
  },

  create(base?: DeepPartial<VariableReferences>): VariableReferences {
    return VariableReferences.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<VariableReferences>): VariableReferences {
    const message = createBaseVariableReferences();
    message.functions = (globalThis.Object.entries(object.functions ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    message.delayResponses = (globalThis.Object.entries(object.delayResponses ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    message.flowSteps = (globalThis.Object.entries(object.flowSteps ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    message.flowNoCodeSteps = (globalThis.Object.entries(object.flowNoCodeSteps ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    message.flowFunctions = (globalThis.Object.entries(object.flowFunctions ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    message.topics = (globalThis.Object.entries(object.topics ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    message.behaviours = (globalThis.Object.entries(object.behaviours ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    message.greetings = (globalThis.Object.entries(object.greetings ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    message.roles = (globalThis.Object.entries(object.roles ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    message.personalities = (globalThis.Object.entries(object.personalities ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    message.sms = (globalThis.Object.entries(object.sms ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    message.startFunctions = (globalThis.Object.entries(object.startFunctions ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    message.endFunctions = (globalThis.Object.entries(object.endFunctions ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseVariableReferences_FunctionsEntry(): VariableReferences_FunctionsEntry {
  return { key: "", value: false };
}

export const VariableReferences_FunctionsEntry: MessageFns<VariableReferences_FunctionsEntry> = {
  encode(message: VariableReferences_FunctionsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VariableReferences_FunctionsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVariableReferences_FunctionsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VariableReferences_FunctionsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: VariableReferences_FunctionsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<VariableReferences_FunctionsEntry>): VariableReferences_FunctionsEntry {
    return VariableReferences_FunctionsEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<VariableReferences_FunctionsEntry>): VariableReferences_FunctionsEntry {
    const message = createBaseVariableReferences_FunctionsEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseVariableReferences_DelayResponsesEntry(): VariableReferences_DelayResponsesEntry {
  return { key: "", value: false };
}

export const VariableReferences_DelayResponsesEntry: MessageFns<VariableReferences_DelayResponsesEntry> = {
  encode(message: VariableReferences_DelayResponsesEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VariableReferences_DelayResponsesEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVariableReferences_DelayResponsesEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VariableReferences_DelayResponsesEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: VariableReferences_DelayResponsesEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<VariableReferences_DelayResponsesEntry>): VariableReferences_DelayResponsesEntry {
    return VariableReferences_DelayResponsesEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<VariableReferences_DelayResponsesEntry>): VariableReferences_DelayResponsesEntry {
    const message = createBaseVariableReferences_DelayResponsesEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseVariableReferences_FlowStepsEntry(): VariableReferences_FlowStepsEntry {
  return { key: "", value: false };
}

export const VariableReferences_FlowStepsEntry: MessageFns<VariableReferences_FlowStepsEntry> = {
  encode(message: VariableReferences_FlowStepsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VariableReferences_FlowStepsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVariableReferences_FlowStepsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VariableReferences_FlowStepsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: VariableReferences_FlowStepsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<VariableReferences_FlowStepsEntry>): VariableReferences_FlowStepsEntry {
    return VariableReferences_FlowStepsEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<VariableReferences_FlowStepsEntry>): VariableReferences_FlowStepsEntry {
    const message = createBaseVariableReferences_FlowStepsEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseVariableReferences_FlowNoCodeStepsEntry(): VariableReferences_FlowNoCodeStepsEntry {
  return { key: "", value: false };
}

export const VariableReferences_FlowNoCodeStepsEntry: MessageFns<VariableReferences_FlowNoCodeStepsEntry> = {
  encode(message: VariableReferences_FlowNoCodeStepsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VariableReferences_FlowNoCodeStepsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVariableReferences_FlowNoCodeStepsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VariableReferences_FlowNoCodeStepsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: VariableReferences_FlowNoCodeStepsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<VariableReferences_FlowNoCodeStepsEntry>): VariableReferences_FlowNoCodeStepsEntry {
    return VariableReferences_FlowNoCodeStepsEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<VariableReferences_FlowNoCodeStepsEntry>): VariableReferences_FlowNoCodeStepsEntry {
    const message = createBaseVariableReferences_FlowNoCodeStepsEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseVariableReferences_FlowFunctionsEntry(): VariableReferences_FlowFunctionsEntry {
  return { key: "", value: false };
}

export const VariableReferences_FlowFunctionsEntry: MessageFns<VariableReferences_FlowFunctionsEntry> = {
  encode(message: VariableReferences_FlowFunctionsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VariableReferences_FlowFunctionsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVariableReferences_FlowFunctionsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VariableReferences_FlowFunctionsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: VariableReferences_FlowFunctionsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<VariableReferences_FlowFunctionsEntry>): VariableReferences_FlowFunctionsEntry {
    return VariableReferences_FlowFunctionsEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<VariableReferences_FlowFunctionsEntry>): VariableReferences_FlowFunctionsEntry {
    const message = createBaseVariableReferences_FlowFunctionsEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseVariableReferences_TopicsEntry(): VariableReferences_TopicsEntry {
  return { key: "", value: false };
}

export const VariableReferences_TopicsEntry: MessageFns<VariableReferences_TopicsEntry> = {
  encode(message: VariableReferences_TopicsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VariableReferences_TopicsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVariableReferences_TopicsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VariableReferences_TopicsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: VariableReferences_TopicsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<VariableReferences_TopicsEntry>): VariableReferences_TopicsEntry {
    return VariableReferences_TopicsEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<VariableReferences_TopicsEntry>): VariableReferences_TopicsEntry {
    const message = createBaseVariableReferences_TopicsEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseVariableReferences_BehavioursEntry(): VariableReferences_BehavioursEntry {
  return { key: "", value: false };
}

export const VariableReferences_BehavioursEntry: MessageFns<VariableReferences_BehavioursEntry> = {
  encode(message: VariableReferences_BehavioursEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VariableReferences_BehavioursEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVariableReferences_BehavioursEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VariableReferences_BehavioursEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: VariableReferences_BehavioursEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<VariableReferences_BehavioursEntry>): VariableReferences_BehavioursEntry {
    return VariableReferences_BehavioursEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<VariableReferences_BehavioursEntry>): VariableReferences_BehavioursEntry {
    const message = createBaseVariableReferences_BehavioursEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseVariableReferences_GreetingsEntry(): VariableReferences_GreetingsEntry {
  return { key: "", value: false };
}

export const VariableReferences_GreetingsEntry: MessageFns<VariableReferences_GreetingsEntry> = {
  encode(message: VariableReferences_GreetingsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VariableReferences_GreetingsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVariableReferences_GreetingsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VariableReferences_GreetingsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: VariableReferences_GreetingsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<VariableReferences_GreetingsEntry>): VariableReferences_GreetingsEntry {
    return VariableReferences_GreetingsEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<VariableReferences_GreetingsEntry>): VariableReferences_GreetingsEntry {
    const message = createBaseVariableReferences_GreetingsEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseVariableReferences_RolesEntry(): VariableReferences_RolesEntry {
  return { key: "", value: false };
}

export const VariableReferences_RolesEntry: MessageFns<VariableReferences_RolesEntry> = {
  encode(message: VariableReferences_RolesEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VariableReferences_RolesEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVariableReferences_RolesEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VariableReferences_RolesEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: VariableReferences_RolesEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<VariableReferences_RolesEntry>): VariableReferences_RolesEntry {
    return VariableReferences_RolesEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<VariableReferences_RolesEntry>): VariableReferences_RolesEntry {
    const message = createBaseVariableReferences_RolesEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseVariableReferences_PersonalitiesEntry(): VariableReferences_PersonalitiesEntry {
  return { key: "", value: false };
}

export const VariableReferences_PersonalitiesEntry: MessageFns<VariableReferences_PersonalitiesEntry> = {
  encode(message: VariableReferences_PersonalitiesEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VariableReferences_PersonalitiesEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVariableReferences_PersonalitiesEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VariableReferences_PersonalitiesEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: VariableReferences_PersonalitiesEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<VariableReferences_PersonalitiesEntry>): VariableReferences_PersonalitiesEntry {
    return VariableReferences_PersonalitiesEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<VariableReferences_PersonalitiesEntry>): VariableReferences_PersonalitiesEntry {
    const message = createBaseVariableReferences_PersonalitiesEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseVariableReferences_SmsEntry(): VariableReferences_SmsEntry {
  return { key: "", value: false };
}

export const VariableReferences_SmsEntry: MessageFns<VariableReferences_SmsEntry> = {
  encode(message: VariableReferences_SmsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VariableReferences_SmsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVariableReferences_SmsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VariableReferences_SmsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: VariableReferences_SmsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<VariableReferences_SmsEntry>): VariableReferences_SmsEntry {
    return VariableReferences_SmsEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<VariableReferences_SmsEntry>): VariableReferences_SmsEntry {
    const message = createBaseVariableReferences_SmsEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseVariableReferences_StartFunctionsEntry(): VariableReferences_StartFunctionsEntry {
  return { key: "", value: false };
}

export const VariableReferences_StartFunctionsEntry: MessageFns<VariableReferences_StartFunctionsEntry> = {
  encode(message: VariableReferences_StartFunctionsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VariableReferences_StartFunctionsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVariableReferences_StartFunctionsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VariableReferences_StartFunctionsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: VariableReferences_StartFunctionsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<VariableReferences_StartFunctionsEntry>): VariableReferences_StartFunctionsEntry {
    return VariableReferences_StartFunctionsEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<VariableReferences_StartFunctionsEntry>): VariableReferences_StartFunctionsEntry {
    const message = createBaseVariableReferences_StartFunctionsEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseVariableReferences_EndFunctionsEntry(): VariableReferences_EndFunctionsEntry {
  return { key: "", value: false };
}

export const VariableReferences_EndFunctionsEntry: MessageFns<VariableReferences_EndFunctionsEntry> = {
  encode(message: VariableReferences_EndFunctionsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VariableReferences_EndFunctionsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVariableReferences_EndFunctionsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VariableReferences_EndFunctionsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: VariableReferences_EndFunctionsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<VariableReferences_EndFunctionsEntry>): VariableReferences_EndFunctionsEntry {
    return VariableReferences_EndFunctionsEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<VariableReferences_EndFunctionsEntry>): VariableReferences_EndFunctionsEntry {
    const message = createBaseVariableReferences_EndFunctionsEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseVariable(): Variable {
  return {
    id: "",
    name: "",
    createdBy: "",
    createdAt: undefined,
    updatedBy: "",
    updatedAt: undefined,
    references: undefined,
  };
}

export const Variable: MessageFns<Variable> = {
  encode(message: Variable, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.createdBy !== "") {
      writer.uint32(26).string(message.createdBy);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(34).fork()).join();
    }
    if (message.updatedBy !== "") {
      writer.uint32(42).string(message.updatedBy);
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(50).fork()).join();
    }
    if (message.references !== undefined) {
      VariableReferences.encode(message.references, writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Variable {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVariable();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.updatedBy = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.references = VariableReferences.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Variable {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      createdBy: isSet(object.createdBy)
        ? globalThis.String(object.createdBy)
        : isSet(object.created_by)
        ? globalThis.String(object.created_by)
        : "",
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      updatedBy: isSet(object.updatedBy)
        ? globalThis.String(object.updatedBy)
        : isSet(object.updated_by)
        ? globalThis.String(object.updated_by)
        : "",
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
      references: isSet(object.references) ? VariableReferences.fromJSON(object.references) : undefined,
    };
  },

  toJSON(message: Variable): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.updatedBy !== "") {
      obj.updatedBy = message.updatedBy;
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.references !== undefined) {
      obj.references = VariableReferences.toJSON(message.references);
    }
    return obj;
  },

  create(base?: DeepPartial<Variable>): Variable {
    return Variable.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Variable>): Variable {
    const message = createBaseVariable();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.createdBy = object.createdBy ?? "";
    message.createdAt = object.createdAt ?? undefined;
    message.updatedBy = object.updatedBy ?? "";
    message.updatedAt = object.updatedAt ?? undefined;
    message.references = (object.references !== undefined && object.references !== null)
      ? VariableReferences.fromPartial(object.references)
      : undefined;
    return message;
  },
};

function createBaseVariables(): Variables {
  return { entities: [] };
}

export const Variables: MessageFns<Variables> = {
  encode(message: Variables, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.entities) {
      Variable.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Variables {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVariables();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.entities.push(Variable.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Variables {
    return {
      entities: globalThis.Array.isArray(object?.entities) ? object.entities.map((e: any) => Variable.fromJSON(e)) : [],
    };
  },

  toJSON(message: Variables): unknown {
    const obj: any = {};
    if (message.entities?.length) {
      obj.entities = message.entities.map((e) => Variable.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<Variables>): Variables {
    return Variables.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Variables>): Variables {
    const message = createBaseVariables();
    message.entities = object.entities?.map((e) => Variable.fromPartial(e)) || [];
    return message;
  },
};

function createBaseVariableCreate(): VariableCreate {
  return { id: "", name: "", references: undefined };
}

export const VariableCreate: MessageFns<VariableCreate> = {
  encode(message: VariableCreate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.references !== undefined) {
      VariableReferences.encode(message.references, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VariableCreate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVariableCreate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.references = VariableReferences.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VariableCreate {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      references: isSet(object.references) ? VariableReferences.fromJSON(object.references) : undefined,
    };
  },

  toJSON(message: VariableCreate): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.references !== undefined) {
      obj.references = VariableReferences.toJSON(message.references);
    }
    return obj;
  },

  create(base?: DeepPartial<VariableCreate>): VariableCreate {
    return VariableCreate.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<VariableCreate>): VariableCreate {
    const message = createBaseVariableCreate();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.references = (object.references !== undefined && object.references !== null)
      ? VariableReferences.fromPartial(object.references)
      : undefined;
    return message;
  },
};

function createBaseVariableUpdate(): VariableUpdate {
  return { id: "", name: "", references: undefined };
}

export const VariableUpdate: MessageFns<VariableUpdate> = {
  encode(message: VariableUpdate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.references !== undefined) {
      VariableReferences.encode(message.references, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VariableUpdate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVariableUpdate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.references = VariableReferences.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VariableUpdate {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      references: isSet(object.references) ? VariableReferences.fromJSON(object.references) : undefined,
    };
  },

  toJSON(message: VariableUpdate): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.references !== undefined) {
      obj.references = VariableReferences.toJSON(message.references);
    }
    return obj;
  },

  create(base?: DeepPartial<VariableUpdate>): VariableUpdate {
    return VariableUpdate.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<VariableUpdate>): VariableUpdate {
    const message = createBaseVariableUpdate();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.references = (object.references !== undefined && object.references !== null)
      ? VariableReferences.fromPartial(object.references)
      : undefined;
    return message;
  },
};

function createBaseVariableDelete(): VariableDelete {
  return { id: "" };
}

export const VariableDelete: MessageFns<VariableDelete> = {
  encode(message: VariableDelete, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VariableDelete {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVariableDelete();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VariableDelete {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: VariableDelete): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create(base?: DeepPartial<VariableDelete>): VariableDelete {
    return VariableDelete.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<VariableDelete>): VariableDelete {
    const message = createBaseVariableDelete();
    message.id = object.id ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(date: Date): Timestamp {
  const seconds = numberToLong(Math.trunc(date.getTime() / 1_000));
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds.toNumber() || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function numberToLong(number: number) {
  return Long.fromNumber(number);
}

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
